import CryptoJS from "crypto-js";

/**
 * Decrypts a PPV stream URL that was AES-256-CBC encrypted on the backend
 * (see API-D1_APP's utils/stream-url-cipher.util.ts, or
 * Admin-All_in_One_Platform's app/Support/StreamUrlCipher.php).
 *
 * The old version of this function just did atob() (base64 "decoding",
 * not real encryption) — trivially reversible, and it broke outright
 * whenever the underlying URL wasn't valid base64. AES-CBC works on raw
 * bytes rather than a restricted character set, so the decrypted URL can
 * contain any characters/symbols (query strings, unicode, spaces, etc.).
 *
 * Payload format: base64(iv (16 bytes) + cipherText). The IV travels
 * with the payload, so nothing else needs to be passed alongside it.
 */
const ENCRYPTION_KEY = process.env.REACT_APP_PPV_STREAM_ENCRYPTION_KEY || "";

export const simpleDecryption = (encodedString: string) => {
  try {
    if (!encodedString) return encodedString;

    if (!ENCRYPTION_KEY) {
      console.error(
        "REACT_APP_PPV_STREAM_ENCRYPTION_KEY is not set — cannot decrypt stream URL."
      );
      return null;
    }

    const raw = CryptoJS.enc.Base64.parse(encodedString);

    // First 16 bytes (4 words) are the IV; the rest is the cipher text.
    const iv = CryptoJS.lib.WordArray.create(raw.words.slice(0, 4), 16);
    const cipherText = CryptoJS.lib.WordArray.create(
      raw.words.slice(4),
      raw.sigBytes - 16
    );

    const decrypted = CryptoJS.AES.decrypt(
      // @ts-ignore - CryptoJS accepts a CipherParams-shaped object here
      { ciphertext: cipherText },
      CryptoJS.enc.Base64.parse(ENCRYPTION_KEY),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decodedString = decrypted.toString(CryptoJS.enc.Utf8);
    return decodedString || null;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};
